export const STORAGE = {
  UPLOAD_ABORT_ERROR_CODE: "ABORT"
};
